import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

// views
import Login from '../containers/views/main/login/index'
import DocumentsStatus from '../containers/views/main/documents/status'
import LabelLanguage from '../containers/views/main/documents/labellanguage'
import DocumentTemplate from '../containers/views/main/documents/template'
import EnrollmentScreen from '../containers/views/main/issuence/enrollmentScreen'


export default () => {

    return (
        <Router>
            <Routes>
                <Route path="/login/:userstate" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Login />} />
                <Route exact path="/documents/status" element={<DocumentsStatus />} />
                <Route exact path="/documents/label-language" element={<LabelLanguage />} />
                <Route exact path="/documents/templates" element={<DocumentTemplate />} />
                <Route exact path="/issuance/enrollment-form" element={<EnrollmentScreen />} />
                <Route exact path="/issuance/update/:id" element={<EnrollmentScreen />} />
            </Routes>
        </Router>
    )

}

